<template>
  <div class="form-select-container font--sm">
    <div class="form-group">
      <select
        class="form-input"
        v-model="selected"
        @change="changed"
      >
        <option value="">
          {{defaultText}}
        </option>
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >
          {{ option.text }}
        </option>
      </select>
      <form-button
        class="icon--btn"
        icon="expand_more"
      ></form-button>
    </div>
  </div>
</template>

<script>
import eventBus from '@/component/common/EventBus'

export default {
  name: 'select-field',
  props: {
    options: { type: Array, required: true },
    defaultText: { type: String, default: '선택해주세요' }
  },
  data () {
    return {
      selected: ''
    }
  },
  created () {
    const { query } = this.$route
    this.selected = query.searchType || ''
  },
  methods: {
    changed (e) {
      const { value } = e.target
      eventBus.$emit('search-type', { searchType: value })

      // let { name, query } = this.$router.currentRoute
      // query = {
      //   ...query,
      //   filter: value
      // }
      // this.$router.replace({ name, query })
    }
  },
  components: {
    FormButton: () => import('@/component/ui2/button/FormButton')
  }
}
</script>
